export default __webpack_public_path__ + "static/site-green-f42221cebd562490e54eea457ef9546d.jpg";